"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var react_redux_firebase_1 = require("react-redux-firebase");
var LoadingSpinner_1 = __importDefault(require("atomicComponents/atoms/Icons/LoadingSpinner"));
var EmptyNotifications_1 = __importDefault(require("components/Notifications/styles/EmptyNotifications"));
var ScrollNotifications_1 = __importDefault(require("components/Notifications/styles/ScrollNotifications"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var other_1 = require("utils/selectors/other");
var utils_1 = require("utils/selectors/utils");
var NotificationsHeader_1 = __importDefault(require("./NotificationsHeader"));
var NotificationWrapper_1 = __importDefault(require("./NotificationWrapper"));
var Notifications = function () {
    var notificationGroups = (0, utils_1.useDebouncedSelector)(other_1.selectNotificationGroups);
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ height: "100%" }, { children: [(0, jsx_runtime_1.jsx)(NotificationsHeader_1.default, { children: (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 3 }, { children: "Notifications" })) }), (0, jsx_runtime_1.jsx)(NotificationWrapper_1.default, { children: (!(0, react_redux_firebase_1.isLoaded)(notificationGroups) && (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ textAlign: "center", mt: 1 }, { children: (0, jsx_runtime_1.jsx)(LoadingSpinner_1.default, { size: "2x" }) })))
                    || (!(notificationGroups === null || notificationGroups === void 0 ? void 0 : notificationGroups.length) && (0, jsx_runtime_1.jsx)(EmptyNotifications_1.default, {}))
                    || (0, jsx_runtime_1.jsx)(ScrollNotifications_1.default, { notificationGroups: notificationGroups }) })] })));
};
exports.default = Notifications;
